import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getFunctions } from 'firebase/functions';

// Firebase configuration - gebruik dezelfde configuratie als je iOS app
const firebaseConfig = {
  apiKey: "AIzaSyD5TKYFcYZGtoOu2cIutO7ifGX93dJaws4",
  authDomain: "kotconnect-adca7.firebaseapp.com",
  projectId: "kotconnect-adca7",
  storageBucket: "kotconnect-adca7.firebasestorage.app",
  messagingSenderId: "413883502630",
  appId: "1:413883502630:web:546bc90caf8fbe8905757d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Auth providers
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

// Initialize Storage with explicit bucket
let storage;
try {
  storage = getStorage(app, firebaseConfig.storageBucket);
} catch (error) {
  try {
    storage = getStorage(app);
  } catch (fallbackError) {
    throw new Error('Firebase Storage could not be initialized.');
  }
}
export { storage };

let messaging = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  });
}
export { messaging };

export const functions = getFunctions(app, 'us-central1');

export default app;
